<div [class]="indicatorClass"></div>
